import axios from 'axios';
import Cookies from 'js-cookie';

const baseURL = '';
const axios_instance = axios.create({
	baseURL,
});

export const indexNews = () => {
	let locale = Cookies.get('locale') ? Cookies.get('locale') : 'tw';
	return axios_instance.get(`news_${locale}.json`);
};

export const indexBanner = () => {
	return axios_instance.get(`banner.json`);
};
